//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-327788 - Cleanup feature flag when released
export const getIsSamplingCampaignsProductSelectionReworkEnabled =
  createHasFeatureSelector(
    FeatureNames.SamplingCampaignsProductSelectionRework,
  );
